<button mat-icon-button class="actions-buttons" *ngIf="showActionsForSelectedZCVersion" [disabled]="isDeleting">
    <mat-icon matTooltip="Clear calculation results" (click)="deleteZCVersion($event)" class="actions-mat-icons">clear
    </mat-icon>
</button>